<template>
  <div class="payment-failed">
    <FailedIcon class="payment-failed__icon" />
    <p class="payment-failed__text">Платіж не пройшов. Спробуйте ще раз або скористайтесь іншою карткою</p>
    <p class="payment-failed__reason">{{ displayMessage }}</p>
  </div>
</template>

<script>
import { default as FailedIcon } from './failed-icon';

export default {
  components: { FailedIcon },
  props: {
    message: {
      type: String,
      default: null,
    },
  },
  computed: {
    displayMessage() {
      return this.message;
    },
  },
};
</script>

<style scoped lang="scss">
.payment-failed {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  padding: 80px;
  margin: 40px 55px 120px;
  border: 1px solid #E4E4E7;
  border-radius: 16px;
  box-shadow: 0px 1px 2px 0px #0000000F, 0px 1px 3px 0px #0000001A;

  @media (max-width: 550px) {
    padding: 40px;
    margin: 25px 25px 50px;
  }

  &__icon {
    margin-bottom: 32px;
  }

  &__text {
    font-size: 32px;
    font-weight: 500;
    text-align: center;
    color: #313437;
    margin: 0;

    @media (max-width: 830px) {
      font-size: 28px;
    }

    @media (max-width: 550px) {
      font-size: 22px;
    }

    @media (max-width: 500px) {
      font-size: 18px;
    }

    @media (max-width: 450px) {
      font-size: 16px;
    }
  }

  &__reason {
    font-size: 16px;
    margin: 0;
  }
}
</style>
